(function ($) {
  $(document).ready(function () {
    const $sections = $(".Stats-with-content-slider");

    if ($sections.length) {
      $sections.each(function () {
        const $section = $(this);

        setTimeout(function () {
          $section.addClass("active");
        }, 200);

        const $sliderOuterItems = $section.find(".slider-outer");

        // 🔹 Loop through each .slider-outer
        $sliderOuterItems.each(function () {
          const $slide = $(this);
          const $stats = $slide.find(".stats");

          if ($stats.length) {
            const rowCount = $stats.find(".row").length;

            if (rowCount === 1) {
              $slide.addClass("has-one-row");
            } else {
              $slide.removeClass("has-one-row");
            }
          }
        });

        // 🔹 Initialize Slick only if more than one .slider-outer exists
        const $statsContent = $section.find(".stats-content");

        if (
          $sliderOuterItems.length > 1 &&
          !$statsContent.hasClass("slick-initialized")
        ) {
          $statsContent.slick({
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: "linear",
          });
        }
      });
    }
  });
})(jQuery);
